import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiAlertTriangle, FiBell, FiLogOut } from "react-icons/fi";
import { Badge, Card } from "components/ui";
import { AccountSettingRow } from "./AccountSettingRow";

interface AccountManageSectionsProps {
  isSubscribe: any;
  handleSubscribe: (e: React.MouseEvent<HTMLSpanElement>) => void;
  onLogout: () => void;
  onShowAccountActions: () => void;
}

/** Preferences (subscription + sign out) and the danger zone. */
export const AccountManageSections = ({
  isSubscribe,
  handleSubscribe,
  onLogout,
  onShowAccountActions,
}: AccountManageSectionsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Card title="Preferences" subtitle="Control survey emails and your current session." flush>
        <div className="divide-y divide-line">
          <AccountSettingRow
            icon={<FiBell />}
            label="Email subscription"
            description="Your Zamplia Surveys email subscription."
            action={
              <p className="cursor-pointer">
                {isSubscribe ? (
                  <span>
                    <Link to={"/unsubscribe"} className="zs-btn zs-btn-secondary zs-btn-sm">
                      {t("Account.Button.Unsubscribe")}
                    </Link>
                  </span>
                ) : (
                  <span onClick={handleSubscribe} className="zs-btn zs-btn-primary zs-btn-sm">
                    {t("Account.Button.Subscribe")}
                  </span>
                )}
              </p>
            }
          >
            <Badge tone={isSubscribe ? "success" : "neutral"} dot>
              {isSubscribe ? "Subscribed" : "Not subscribed"}
            </Badge>
          </AccountSettingRow>

          <AccountSettingRow
            icon={<FiLogOut />}
            label={t("Account.Button.Log_out")}
            description="Sign out of Zamplia Surveys on this device."
            action={
              <button onClick={onLogout} className="zs-btn zs-btn-secondary zs-btn-sm">
                <FiLogOut className="w-3.5 h-3.5" />
                {t("Account.Button.Log_out")}
              </button>
            }
          />
        </div>
      </Card>

      <section className="zs-card border-danger/30">
        <div className="zs-card-header border-danger/20">
          <div className="min-w-0">
            <h2 className="flex items-center gap-2 zs-card-title text-danger">
              <FiAlertTriangle className="w-4 h-4" />
              Danger zone
            </h2>
            <p className="mt-0.5 zs-card-subtitle">Actions here affect your access to your account.</p>
          </div>
        </div>
        <div className="flex flex-col gap-4 zs-card-body sm:flex-row sm:items-center sm:justify-between">
          <div className="min-w-0">
            <p className="text-sm font-medium text-ink">Deactivate or delete account</p>
            <p className="mt-0.5 text-sm text-ink-3">
              Deactivation prevents future sign-ins. Deletion is permanent.
            </p>
          </div>
          <button
            type="button"
            onClick={onShowAccountActions}
            className="zs-btn zs-btn-secondary text-danger border-danger/40 hover:!bg-danger-soft hover:!text-danger shrink-0"
          >
            Deactivate or delete account
          </button>
        </div>
      </section>
    </>
  );
};
